import { createApp } from "vue";
import { createPinia } from "pinia";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
// Opt-in compact-density theme (saas-core >= v0.5.0-alpha.16) — matches Bug
// Tracker's data-dense corporate look. Must load AFTER Bootstrap. Brand accent
// follows --ds-shell-accent (set once → shell chrome + screen buttons follow).
import "@digitalstreams/saas-core/vue/styles/tokens.css";
import "@digitalstreams/saas-core/vue/styles/density.css";

import App from "./App.vue";
import router from "./router";

const app = createApp(App);
app.use(createPinia());
app.use(router);

app.mount("#app");
